export default __webpack_public_path__ + "static/media/subscriptions_round_icon.d68bc1fe.svg";